import React from "react";
import Avatar from "react-avatar";
import type { ReactAvatarProps } from "react-avatar";

export function AuresAvatar(props: ReactAvatarProps) {
    return <Avatar {...props} round={true} />;
}
